module.exports = __webpack_public_path__ + "static/img/big-1.8991278.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/big-1.png
// module id = wCvP
// module chunks = 1